// test1774
(1774 && 0);
